// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1kagy","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3OJJS"};